if (customElements.get("full-menu")) {
  document.addEventListener("DOMContentLoaded", () => {
    const menuItems = document.querySelectorAll(
      ".thb-full-menu > .menu-item-has-children"
    );

    let closeTimer = null;
    let currentOpen = null;

    menuItems.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        // Direct openen
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        if (currentOpen && currentOpen !== item) {
          currentOpen.classList.remove("is-hovering");
        }
        item.classList.add("is-hovering");
        currentOpen = item;
      });

      item.addEventListener("mouseleave", () => {
        // 300ms vertraging bij sluiten
        closeTimer = setTimeout(() => {
          item.classList.remove("is-hovering");
          if (currentOpen === item) currentOpen = null;
        }, 300);
      });
    });
  });
}